import React, { useEffect, useState } from 'react';
import {
  Paper, Typography, Box, Button, Table, TableBody, TableCell, TableHead, TableRow,
  Chip, CircularProgress, Alert
} from '@mui/material';
import axios from '../../api/client';
import { toast } from 'react-toastify';
import { useCurrency } from '../../context/CurrencyContext';
import ScrollTable from '../ScrollTable';

const RentIncreases = () => {
  const { formatMoney } = useCurrency();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const res = await axios.get('/rent-increases');
      setRows(res.data || []);
    } catch (error) {
      toast.error(error.response?.data?.message || 'Could not load rent increases');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const respond = async (id, action) => {
    try {
      await axios.post(`/rent-increases/${id}/${action}`);
      toast.success(action === 'accept' ? 'Accepted — new rent applies from the effective date' : 'Declined');
      load();
    } catch (error) {
      toast.error(error.response?.data?.message || `Could not ${action}`);
    }
  };

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>Rent increases</Typography>
      <Alert severity="info" sx={{ mb: 2 }}>
        If you accept, the new rent starts on the effective date. Declining does not start an
        exit by itself — contact the agency if you intend to leave.
      </Alert>
      {loading ? <CircularProgress /> : (
        <ScrollTable>
          <TableHead>
            <TableRow>
              <TableCell align="right">Current</TableCell>
              <TableCell align="right">New</TableCell>
              <TableCell align="right">Increment</TableCell>
              <TableCell>Notice period</TableCell>
              <TableCell>Effective</TableCell>
              <TableCell>Respond by</TableCell>
              <TableCell>Status</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((r) => (
              <TableRow key={r.id}>
                <TableCell align="right">{formatMoney(r.currentRent)} {r.currency}</TableCell>
                <TableCell align="right">{formatMoney(r.newRent)} {r.currency}</TableCell>
                <TableCell align="right">{formatMoney(r.incrementAmount)} {r.currency}</TableCell>
                <TableCell>{r.noticePeriodDays} days</TableCell>
                <TableCell>{r.effectiveDate}</TableCell>
                <TableCell>{r.respondByDate}</TableCell>
                <TableCell><Chip size="small" label={r.status} /></TableCell>
                <TableCell>
                  {r.status === 'pending' && (
                    <Box display="flex" gap={1}>
                      <Button size="small" variant="contained" onClick={() => respond(r.id, 'accept')}>
                        Accept
                      </Button>
                      <Button size="small" variant="outlined" onClick={() => respond(r.id, 'decline')}>
                        Decline
                      </Button>
                    </Box>
                  )}
                </TableCell>
              </TableRow>
            ))}
            {!rows.length && (
              <TableRow><TableCell colSpan={8}>No rent increase notices.</TableCell></TableRow>
            )}
          </TableBody>
        </ScrollTable>
      )}
    </Paper>
  );
};

export default RentIncreases;
